import { Box, Button, TextField, Typography } from "@mui/material";
import Detail from "../../main/detail/Detail";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseMyPC } from "../../hooks/UseMyPC";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useEffect, useState } from "react";
import ProgressCom from "../../components/ProgressCom";
import CustomPagination from "../../components/CustomPagination";
import { UseFractionalList } from "./UseFractionalList";
import { useLocation, useNavigate } from "react-router-dom";
import OrderDetail from "./OrderDetail";

export default function FractionalList() {
  const location = useLocation();
  const navigate = useNavigate();

  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { myPc, goToFirstPage, updatePage, updateSort, refresh } = UseMyPC();
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : "",
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : "",
  );
  const [fractionalList, setFractionalList] = useState();
  const { getFractionalList } = UseFractionalList();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [openDetails, setOpenDetails] = useState({
    show: false,
    orderId: null,
  });

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getFractionalList(
      myPc,
      search,
      (fractionas) => {
        setFractionalList(fractionas);
      },
      true,
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "shamsiDeliverdate",
      headerName: "تاریخ",
      width: 200,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.shamsiDeliverdate}
          </Typography>
        );
      },
    },
    {
      field: "state1",
      headerName: "نامشخص",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "state2",
      headerName: "تایید شده",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "state4",
      headerName: "بررسی شده",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "state5",
      headerName: "در حال ارسال",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Button
            onClick={() => {
              navigate("/fractionallist/orders", {
                state: {
                  date: cellValues.row.deliverdate.split("T")[0],
                },
              });
            }}
            variant="contained"
          >
            سفارشات
          </Button>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/fractionallist",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            // justifyContent: "space-between",
          }}
        >
          <TextField
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            type="number"
            InputProps={{
              inputProps: {
                min: 1,
              },
            }}
            label="سفارش"
            value={openDetails.orderId}
            placeholder="جستجو سفارش"
            onChange={(e) =>
              setOpenDetails({ show: false, orderId: e.target.value })
            }
          />
          <Button
            variant="contained"
            color="secondary"
            onClick={() =>
              setOpenDetails({
                ...openDetails,
                show: true,
              })
            }
          >
            نمایش
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {fractionalList ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              rows={fractionalList.orders ?? []}
              paginationMode="server"
              page={fractionalList.pageCondition.page - 1}
              pageSize={fractionalList.pageCondition.pageCount}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={fractionalList.pageCondition.totalItemCount}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc",
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount:
                    fractionalList &&
                    fractionalList.pageCondition.totalItemCount
                      ? fractionalList.pageCondition.totalItemCount
                      : "",
                },
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
      {openDetails.show && (
        <OrderDetail
          open={openDetails}
          setOpen={setOpenDetails}
          orderID={openDetails.orderId}
        />
      )}
    </Detail>
  );
}
